module.exports = __webpack_public_path__ + "img/TADA.22c14ec2.png";